import { render, staticRenderFns } from "./iDSMyInfo.vue?vue&type=template&id=2a809b7d"
import script from "./iDSMyInfo.vue?vue&type=script&lang=js"
export * from "./iDSMyInfo.vue?vue&type=script&lang=js"
import style0 from "./iDSMyInfo.vue?vue&type=style&index=0&id=2a809b7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports